import { render, staticRenderFns } from "./CompetitorsSupplies.vue?vue&type=template&id=67f9acdb&scoped=true&"
import script from "./CompetitorsSupplies.vue?vue&type=script&lang=js&"
export * from "./CompetitorsSupplies.vue?vue&type=script&lang=js&"
import style0 from "./CompetitorsSupplies.vue?vue&type=style&index=0&id=67f9acdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f9acdb",
  null
  
)

export default component.exports